import { Modal } from 'react-bootstrap';

import { Product } from 'interfaces/interfaces';

interface SetupAutoPayReminderProps {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  handlePayNow: (selectedProduct: Product | null) => void;
  payNowProduct: Product | null;
  handleChangeFreqAutoPay: (selectedProduct: Product) => Promise<void>;
  selectedProduct: Product | null;
}

const SetupAutoPayReminder = ({
  show,
  setShow,
  handlePayNow,
  payNowProduct,
  handleChangeFreqAutoPay,
  selectedProduct,
}: SetupAutoPayReminderProps) => {
  const handleClickYes = () => {
    setShow(false);
    handleChangeFreqAutoPay(selectedProduct!);
  };

  return (
    <Modal
      backdrop="static"
      show={show}
      onHide={() => {
        setShow(false);
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title>Setup Auto Pay</Modal.Title>
      </Modal.Header>
      <Modal.Body>Would you like to setup Auto Pay at this time?</Modal.Body>
      <Modal.Footer>
        <button
          onClick={() => {
            setShow(false);
            handlePayNow(payNowProduct);
          }}
          type="button"
          className="btn agiaBlueButton-outline"
          data-dismiss="modal"
        >
          No
        </button>

        <button onClick={handleClickYes} type="button" className="btn agiaBlueButton" data-dismiss="modal">
          Yes
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default SetupAutoPayReminder;
